import localforage from "localforage";

function getImageStore() {
  const iamgeStore = localforage.createInstance({
    driver: localforage.INDEXEDDB,
    name: "app4aimsIamgeStore"
  });
  return iamgeStore;
}

export function saveImage(imageString, uuid) {
  const store = getImageStore();
  return store.setItem(uuid, imageString);
}

export function getImage(uuid) {
  const store = getImageStore();
  return store.getItem(uuid);
}

export function deleteImage(uuid) {
  const store = getImageStore();
  return store.removeItem(uuid);
}

export function clearAllImages() {
  const store = getImageStore();
  store.clear();
}